export default {"src":"/_next/static/media/logo_green_41x34.896ceb72.svg","height":34,"width":41,"blurWidth":0,"blurHeight":0};